import { render, staticRenderFns } from "./qDetailModal.vue?vue&type=template&id=2833480a&"
import script from "./qDetailModal.vue?vue&type=script&lang=ts&"
export * from "./qDetailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports